import { api } from "./api";

export const getstatusLogin = () => {
    return api.get("drilling_mechanics/")
};

